<template>
  <div class="page-wrapper">
    <div class="container-custom heading">
      <TitlesDescriptionComponent :size="'small'" :title="$t('team-page-title')"/>
      <div class="team-heading-wrapper">
        <div class="team-heading-description "> {{ $t('team-heading-paragraph') }}</div>
        <div class="team-heading-placeholder"> {{ $t('team-heading-filter-placeholder') }}:</div>
        <div class="col-md-3 col-12" @click="showModal">
          <MainButton :button-text="$t('team-button-choose-specialty')" :icon="'filter'" :size="'large'"
                      :theme="'solid-white-brown'"/>
        </div>
      </div>
    </div>

    <div v-if="specialists" class="row container-custom">
      <div v-for="(specialist, index) in specialists" :key="index" class="col-md-3 col-12 one-specialist">
        <router-link :to="{name: 'OneDoctorView', params: { id: specialist.id } }">
          <OneSpecialistThumbnail :category="specialist.content.category.value"
                                  :img-src="specialist.content.imageUrl[0]"
                                  :title="specialist.content.name"
                                  size="full"/>
        </router-link>
      </div>
    </div>
    <div>
      <ModalMain ref="modalComponent">
        <div v-if="offices">
          <ModalSpecialties v-model="selectedOffices" :offices="offices.data"/>
        </div>
      </ModalMain>
    </div>
  </div>
</template>

<script>


import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import OneSpecialistThumbnail from "@/components/Components/OneSpecialistThumbnail/OneSpecialistThumbnail.vue";
import ModalMain from "@/components/Components/ModalMain/ModalMain.vue";
import ModalSpecialties from "@/components/Components/ModalMain/ModalSpecialties.vue";


export default {
  name: 'TeamView',
  components: {
    ModalSpecialties,
    ModalMain,
    OneSpecialistThumbnail,
    MainButton,
    TitlesDescriptionComponent,

  },

  data() {
    return {
      specialists: null,
      offices: [],
      selectedOffices: []
    };
  },
  watch: {
    selectedOffices: {
      async handler() {
        await this.filterTeam();
        this.$refs.modalComponent.hideModal();
      },
      deep: true,
      immediate: true
    },
  },
  async mounted() {
    this.offices = await this.$store.dispatch("offices/getOffices");
    await this.filterTeam();
  },
  methods: {
    showModal() {
      this.$refs.modalComponent.showModal();
    },
    hideModal() {
      this.$refs.modalComponent.hideModal();
    },
    async filterTeam() {
      const response = await this.$store.dispatch("specialists/getSpecialists");
      this.specialists = response.data;
      this.hideModal();
      if (this.selectedOffices.length === 0) {
        return;
      }
      let vm = this;
      this.specialists = this.specialists.filter((specialist) => {
        return vm.selectedOffices.includes(specialist.content.category.id);
      });
    },
  },

};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.heading {
  margin-top: 90px;
  margin-bottom: 50px;
}

.team-heading-wrapper {
  padding: 30px;
  background: $color-grey;
  color: $color-brown;
  border-radius: 30px;

  .team-heading-description {
    font-size: $paragraph-1;
    margin-bottom: $spacing-8;
  }

  .team-heading-placeholder {
    font-size: $paragraph-1;
    margin-bottom: $spacing-2;
  }
}

.one-specialist {
  margin: $spacing-2 0;
}


@media screen and (min-width: 768px) {
  .heading {
    margin-top: 100px;
  }
  .team-heading-wrapper {
    padding: 80px 100px;

    .team-heading-description {
      max-width: 70%;
      font-size: 28px;
    }
  }

}
</style>